import React, { useState } from "react";

import LinkIcon from "@material-ui/icons/Link";
import GetAppIcon from "@material-ui/icons/GetApp";
import { Checkbox, Grid, Tooltip } from "@material-ui/core";
import { notify } from "../../utils/notify";

import { v4 as uuidv4 } from "uuid";
import filesize from "filesize";
import Swal from "sweetalert2";
import Dropzone from "react-dropzone";

import {
  ContainerIndex,
  Content,
  DropContainer,
  UploadMessage,
  Container,
  FileInfo,
  Preview,
  LinkModal,
} from "./styles/UploadFiles";
import ModalPhoto from "./children/ModalPhoto";

export default function UploadFiles({
  uploadedFiles = [],
  setUploadedFiles = () => {},
  accept = "image/*",
  label = "Arraste arquivos aqui...",
  multiple = false,
  main,
  maxHeightListLarge = "",
  maxHeightListSmall = "",
  previewFile = true,
  downloadFile = false,
}) {
  const [modalPhotoOpen, setModalPhotoOpen] = useState(false);
  const [modalPhotoContent, setModalPhotoContent] = useState(null);

  const handleOpenPhoto = (photo) => {
    setModalPhotoContent(photo);
    setModalPhotoOpen(true);
  };

  const getFileExtension = (fileName) => {
    var fileExtension;
    fileExtension = fileName.replace(/^.*\./, "");
    return fileExtension;
  };

  const isImage = (fileName) => {
    var fileExt = getFileExtension(fileName);
    var imagesExtension = ["png", "jpg", "jpeg"];
    if (imagesExtension.indexOf(fileExt.toLowerCase()) !== -1) {
      return true;
    } else {
      return false;
    }
  };

  const handleDownloadFile = (fileObj) => {
    const file = fileObj.file;
    if (!file || typeof file !== "string") return;

    try {
      var element = document.createElement("a");

      element.setAttribute(
        "href",
        "data:application/octet-stream;base64," +
          encodeURIComponent(
            file.substring(file.split("").findIndex((e) => e === ",") + 1)
          )
      );

      element.setAttribute("download", fileObj.name);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);

      return true;
    } catch (error) {
      console.error("error ButtonsAccountant executeDownload:", error);
      return false;
    }
  };

  const handleUpload = (files) => {
    if (!multiple) {
      const file = files[0];

      setUploadedFiles([
        {
          file,
          id: uuidv4(),
          name: file.name,
          readableSize: filesize(file.size),
          preview: isImage(file.name) ? URL.createObjectURL(file) : undefined,
          checkMain: true,
          uploaded: true,
          error: false,
        },
      ]);

      return;
    }

    let checkMain = false;
    if (!uploadedFiles.find((file) => file.checkMain || file.principal)) {
      checkMain = true;
    }

    const uploadeds = files.map((file, i) => ({
      file,
      id: uuidv4(),
      name: file.name,
      readableSize: filesize(file.size),
      preview: isImage(file.name) ? URL.createObjectURL(file) : undefined,
      uploaded: true,
      error: false,
      checkMain: !i && checkMain,
      index: i,
    }));

    setUploadedFiles(uploadedFiles.concat(uploadeds));
  };

  const handleDelete = (id, index = null) => {
    if (
      main &&
      uploadedFiles.find((current) => current.id === id && current.checkMain)
    )
      return notify("Atribua outra imagem como principal antes de excluir.");

    Swal.fire({
      icon: "question",
      text: "Tem certeza que deseja remover?",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Sim",
      showConfirmButton: true,
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setUploadedFiles(uploadedFiles.filter((file) => file.id !== id));
      }
    });
  };

  const handleCheckMain = (id) => {
    const newArr = uploadedFiles.map((item) => {
      if (item.id === id) {
        return { ...item, checkMain: item.checkMain ? false : true };
      }

      return { ...item, checkMain: false };
    });

    setUploadedFiles(newArr);
  };

  return (
    <ContainerIndex>
      {modalPhotoOpen && (
        <ModalPhoto
          modalPhotoOpen={modalPhotoOpen}
          setModalPhotoOpen={setModalPhotoOpen}
          photo={modalPhotoContent}
          setModalPhotoContent={setModalPhotoContent}
        />
      )}
      <Content>
        <Dropzone accept={accept} onDropAccepted={handleUpload}>
          {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
            <DropContainer
              {...getRootProps()}
              isDragActive={isDragActive}
              isDragReject={isDragReject}
            >
              <input {...getInputProps()} multiple={multiple} />
              <UploadMessage>
                {isDragActive && !isDragReject
                  ? "Solte os arquivos aqui"
                  : isDragReject
                  ? "Arquivo não suportado"
                  : label}
              </UploadMessage>
            </DropContainer>
          )}
        </Dropzone>
        {!!uploadedFiles.length && (
          <Container
            maxHeightListLarge={maxHeightListLarge}
            maxHeightListSmall={maxHeightListSmall}
          >
            {uploadedFiles.map((uploadedFile) => (
              <li key={uploadedFile.id}>
                <FileInfo>
                  {previewFile &&
                    uploadedFile.preview &&
                    isImage(uploadedFile.name) && (
                      <Preview src={uploadedFile.preview} />
                    )}
                  <div>
                    <strong>{uploadedFile.name}</strong>
                    <span>
                      {uploadedFile.readableSize}
                      <button
                        onClick={() =>
                          handleDelete(
                            uploadedFile?.id,
                            uploadedFile?.index ?? null
                          )
                        }
                      >
                        Remover
                      </button>
                    </span>
                  </div>
                </FileInfo>
                {(downloadFile || previewFile) && (
                  <Grid container alignItems="center" justifyContent="flex-end">
                    {uploadedFile.preview && isImage(uploadedFile.name) && (
                      <Grid item flex={1}>
                        <Tooltip title="Abrir arquivo">
                          <LinkModal
                            onClick={() =>
                              handleOpenPhoto(uploadedFile.preview)
                            }
                          >
                            <LinkIcon
                              style={{ marginRight: 8, color: "black" }}
                              size={24}
                            />
                          </LinkModal>
                        </Tooltip>
                      </Grid>
                    )}

                    {downloadFile && (
                      <Grid item flex={1}>
                        <Tooltip title="Baixar arquivo">
                          <LinkModal
                            onClick={() => handleDownloadFile(uploadedFile)}
                          >
                            <GetAppIcon
                              style={{ marginRight: 8, color: "black" }}
                              size={24}
                            />
                          </LinkModal>
                        </Tooltip>
                      </Grid>
                    )}

                    {main && (
                      <Grid item flex={1}>
                        <Tooltip title="Marcar Principal">
                          <Checkbox
                            checked={uploadedFile.checkMain || false}
                            onChange={() => handleCheckMain(uploadedFile.id)}
                            size="small"
                            inputProps={{
                              "aria-label": "checkbox with small size",
                            }}
                          />
                        </Tooltip>
                      </Grid>
                    )}
                  </Grid>
                )}
              </li>
            ))}
          </Container>
        )}
      </Content>
    </ContainerIndex>
  );
}
